import { useCallback, useEffect, useRef, useState } from 'react';

export const useShowMore = (closedHeight, triggerHeight) => {
    const containerRef = useRef();
    const [contentHeight, setContentHeight] = useState(0);
    const [overflowCount, setOverflowCount] = useState(0);
    const [showMore, setShowMore] = useState(false);
    const calculateShowMore = useCallback(() => {
        const el = containerRef.current;
        if (!el) {
            setContentHeight(0);
            setOverflowCount(0);
            return;
        }
        setContentHeight(el.scrollHeight);
        setOverflowCount(
            [...el.children].filter(
                x => x.offsetTop + x.clientHeight * 0.75 >= closedHeight
            ).length
        );
    }, [closedHeight]);
    useEffect(() => {
        calculateShowMore();
        window.addEventListener('resize', calculateShowMore);
        return () => window.removeEventListener('resize', calculateShowMore);
    }, [calculateShowMore]);
    return {
        isOverflowing: contentHeight > triggerHeight,
        overflowCount,
        toggleShowMore: () => setShowMore(!showMore),
        containerStyle:
            contentHeight <= triggerHeight
                ? {}
                : showMore
                ? { maxHeight: contentHeight, overflow: 'hidden' }
                : { maxHeight: closedHeight, overflow: 'hidden' },
        isShowingMore: showMore,
        containerRef
    };
};
